var scrollTop = $('.scroll-top');
var scrollTopButton = $('.scroll-top__button');

$(window).on('scroll', function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        scrollTop.addClass('active');
    } else {
        scrollTop.removeClass('active');
    }
});

$(scrollTopButton).on('click', function() {
    $('html, body').animate(
        {
            scrollTop: 0,
        },
        1000
    );
});

// $('body,html').on('scroll mousedown wheel DOMMouseScroll mousewheel keyup', function(e) {
//     if (e.which > 0 || e.type == 'mousedown' || e.type == 'mousewheel') {
//         $('html,body').stop();
//     }
// });

const page = $('html, body');

page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function() {
    page.stop();
});
